// Auth API service - communicates with the Node.js backend
// Passwords are SHA-256 hashed client-side before sending

// In production (cloudsapps.net), Nginx proxies /api/ to the backend
// In development (localhost), we connect directly to the Node server
const API_URL = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1'
  ? (process.env.REACT_APP_API_URL || 'http://localhost:4000')
  : ''; // Empty = use same origin (via Nginx proxy)

// Hash password using SHA-256 via Web Crypto API (native, no extra dependencies)
async function hashPassword(password) {
  const encoder = new TextEncoder();
  const data = encoder.encode(password);
  const hashBuffer = await crypto.subtle.digest('SHA-256', data);
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  const hashHex = hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
  return hashHex;
}

export async function loginApi(username, password) {
  // Hash the password client-side before sending
  const hashedPassword = await hashPassword(password);

  const response = await fetch(`${API_URL}/api/login`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ username, password: hashedPassword }),
  });

  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.error || 'Login failed');
  }

  return data; // { token, user: { username, name } }
}

export async function logoutApi(token) {
  const response = await fetch(`${API_URL}/api/logout`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`,
    },
  });

  if (!response.ok) {
    console.warn('Logout API call failed, but token will be removed locally.');
  }

  return true;
}

export async function getMe(token) {
  const response = await fetch(`${API_URL}/api/me`, {
    method: 'GET',
    headers: {
      'Authorization': `Bearer ${token}`,
    },
  });

  if (!response.ok) {
    throw new Error('Token invalid or expired');
  }

  const data = await response.json();
  return data.user;
}